


const isProd = process.env.NODE_ENV === "production";


export const API_BASE_URL = isProd ? "https://api.flokitools.fun/api":"http://localhost:3001/api";

export const SITE_NAME =isProd?"flokitools.fun": "***** .fun";